<template>
    <div class="dynamic-quick-reply-message-editor" :key="renderId">
        <div class="mb-2 w-100">
            <div class="mb-1" style="color: #475e7a; font-weight: 600">Data Source:</div>
            <TiptapEditor
                :placeholder="'Enter data source attribute'"
                :show-attributes="true"
                v-model="clone.dataSource"
                :whatsapp-mode="false"
                :allowed-attributes="allowedAttributes"
                :preview-mode="previewMode"
            />
        </div>

        <TiptapEditor
            :placeholder="$t('chatbotv2.enterYourMessage')"
            :show-attributes="showAttributes"
            :show-emoji="showEmoji"
            :max-character-count="640"
            v-model="clone.message"
            :whatsapp-mode="whatsappMode"
            :allowed-attributes="allowedAttributes"
            :show-emoji-picker="showEmojiPicker"
        />

        <div class="quick-replies">
            <div class="quick-reply">
                <a-popover
                    :visible="editingButtonPopupVisible"
                    placement="left"
                    @visibleChange="visibleChange"
                    trigger="click"
                    :overlayClassName="'no-padding'"
                >
                    <div slot="content">
                        <ActionButtonUpdater
                            v-model="clone.buttonTemplate"
                            :on-completed="onButtonUpdateCompleted"
                            :popup-visible="editingButtonPopupVisible"
                            :flattedDiagram="flattedDiagram"
                            :whatsapp-mode="whatsappMode"
                            :allowed-attributes="allowedAttributes"
                            :dynamic-button-message-editor="true"
                            :allowedMessageTypes="['SEND_MESSAGE']"
                        />
                    </div>
                    <div class="quick-reply-text">{{ clone.buttonTemplate.title }}</div>
                </a-popover>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import ActionButtonUpdater from "../../common/ActionButtonUpdater";
import _ from "lodash";

const log = log2("DynamicQuickReplyMessageEditor");
export default {
    name: "DynamicQuickReplyMessageEditor",
    components: { TiptapEditor, ActionButtonUpdater },
    props: {
        value: {
            type: Object,
            required: true,
        },
        flattedDiagram: {
            type: Array,
            default: () => [],
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        showEmoji: {
            type: Boolean,
            default: true,
        },
        showAttributes: {
            type: Boolean,
            default: true,
        },
        showEmojiPicker: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            editingButtonPopupVisible: false,
            renderId: 0,
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        visibleChange(visible) {
            const attributeFormIsEnabled = !!document.getElementById("add-custom-attr-modal");
            log("visibleChange", { visible, attributeFormIsEnabled });
            if (!visible && attributeFormIsEnabled) {
                return;
            }
            this.editingButtonPopupVisible = visible;
            this.renderId++;
        },
        onButtonUpdateCompleted() {
            this.editingButtonPopupVisible = false;
        },
        emitValue() {
            if (!_.isEqual(this.clone, this.value)) {
                log("emitValue", this.clone);
                this.$emit("input", this.clone);
            }
        },
    },
    watch: {
        value: {
            handler(val) {
                log("watch value-->", val);
                this.clone = _.cloneDeep(val);
            },
            deep: true,
        },
        clone: {
            handler(val) {
                log("watch clone-->", val);
                this.emitValue();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.ProseMirror {
    color: #22272d;
    font-size: 16px;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale;
    font-family: Source Sans Pro, sans-serif;
    font-weight: 400;
}

.dynamic-quick-reply-message-editor {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;

    .quick-replies {
        display: flex;
        flex-wrap: wrap;
        margin: 6px -5px 0;
        width: 100%;

        .quick-reply {
            background: #fff;
            border: 1px solid #006cff;
            border-radius: 16px;
            color: #006cff;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            height: 32px;
            line-height: 30px;
            margin: 10px 5px 0;
            min-width: 100px;
            padding: 0 16px;
            position: relative;
            text-align: center;
            transition: all 0.3s;

            .quick-reply-text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style> 